/**
 * ─────────────────────────────────────────────────────────────────────
 * FILE: src/components/Layout/Layout.tsx
 * DESCRIPTION: Main layout component that wraps all protected routes.
 *              Provides persistent sidebar navigation and main content
 *              area for the application.
 *
 * FEATURES:
 * - Persistent sidebar navigation across all protected routes
 * - Main content area with proper spacing and overflow handling
 * - Responsive layout optimized for desktop
 *
 * @copyright 2025-2026 Anou. All rights reserved.
 * @author Anou
 * @version 1.0.0
 * @created 2026-03-26
 * @updated 2026-03-26 - Added Header component, removed duplicate code from pages
 * ─────────────────────────────────────────────────────────────────────
 */

import Sidebar from './Sidebar';
import Header from './Header';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar />
      <div className="flex-1 ml-[250px]">
        <Header />
        <main className="pt-[60px] overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
